import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CookieModule } from 'ngx-cookie';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
    imports: [InfiniteScrollModule, CookieModule.forRoot(), FontAwesomeModule],
    exports: [ReactiveFormsModule, FormsModule, CommonModule, NgbModule, InfiniteScrollModule, FontAwesomeModule]
})
export class NewssoappSharedLibsModule {
    static forRoot() {
        return {
            ngModule: NewssoappSharedLibsModule
        };
    }
}
